const messages = {
  MISSING_CREDENTIALS: "Introduce tu usuario y contraseña.",
  INVALID_CREDENTIALS: "El usuario o la contraseña no son correctos. Revisa los datos e inténtalo de nuevo.",
  NO_TOKEN: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
  INVALID_TOKEN: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
  TWO_FACTOR_REQUIRED: "Introduce el código de verificación que has recibido por correo.",
  INVALID_2FA_CODE: "El código de verificación no es correcto. Revísalo e inténtalo de nuevo.",
  EXPIRED_2FA_CODE: "El código de verificación ha caducado. Vuelve a iniciar sesión para recibir otro.",
  SIGNUP_TOO_SOON: "Debes esperar al menos 2 minutos entre fichajes.",
  DUPLICATE_RECORD: "Ya existe un registro con esos datos. Revísalos antes de guardar.",
  INVALID_DATA: "Hay datos incompletos o incorrectos. Revisa el formulario.",
};

export const isAuthRequest = (url = "") =>
  /\/user\/(login|check2FA)\/?$/.test(url);

export const isAuthResponse = (response) =>
  response?.status === 200 &&
  !!response.data?.resUser?._id &&
  typeof response.data?.access_token === "string" &&
  response.data.access_token.length > 0;

// Solo mostramos textos propios: nunca excepciones, HTML o mensajes arbitrarios del servidor.
export const getErrorMessage = (error, context = "") => {
  const response = error?.response || error;
  const status = response?.status;
  const data = response?.data;
  const code = data?.error_code;
  const url = error?.config?.url || response?.config?.url || "";
  const isLogin = context === "login" || /\/user\/login\/?$/.test(url);
  const is2FA = context === "2fa" || /\/user\/check2FA\/?$/.test(url);

  if (Object.prototype.hasOwnProperty.call(messages, code)) return messages[code];
  if (status === 300 && (isLogin || is2FA)) return messages.TWO_FACTOR_REQUIRED;
  // Compatibilidad con la API anterior durante el despliegue.
  if (data?.message === "Debes esperar al menos 2 minutos entre registros" ||
      data?.message === "No puedes actualizar el registro tan pronto" ||
      (status === 402 && /\/singUp(?:\/|$)/.test(url))) {
    return messages.SIGNUP_TOO_SOON;
  }
  if (is2FA && (data === "Código incorrecto" || status === 401)) return messages.INVALID_2FA_CODE;
  if (status === 401) return isLogin ? messages.INVALID_CREDENTIALS : messages.INVALID_TOKEN;
  if (error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT" || status === 408 || status === 504) {
    return "La conexión está tardando demasiado. Comprueba tu conexión e inténtalo de nuevo.";
  }
  if (/\/singUp(?:\/|$)/.test(url) && /^(post|put)$/i.test(error?.config?.method || "") &&
      ((!status && (error?.request || error?.code === "ERR_NETWORK")) || status >= 500)) {
    return "No se ha podido confirmar el fichaje. Consulta tus accesos antes de volver a intentarlo. Si el problema continúa, contacta con administración.";
  }
  if (!status && (error?.request || error?.code === "ERR_NETWORK" || error?.message === "Network Error")) {
    return "No se ha podido conectar con el servicio. Comprueba tu conexión a Internet e inténtalo de nuevo.";
  }
  if (status === 403) return "No tienes permiso para realizar esta acción. Contacta con administración.";
  if (status === 404) return "No se ha encontrado la información solicitada. Actualiza la página e inténtalo de nuevo.";
  if (status === 409) return messages.DUPLICATE_RECORD;
  if (status === 400 || status === 422) return messages.INVALID_DATA;
  if (status === 413) return "El archivo es demasiado grande. Selecciona uno más pequeño.";
  if (status === 429) return "Se han realizado demasiados intentos. Espera unos minutos antes de volver a intentarlo.";
  if (status >= 500) return "El servicio no está disponible en este momento. Inténtalo de nuevo en unos minutos.";
  return "No se ha podido completar la operación. Inténtalo de nuevo. Si el problema continúa, contacta con administración.";
};

export const normalizeRequestError = (error) => {
  const normalized = new Error(getErrorMessage(error));
  normalized.name = "RequestError";
  normalized.code = error?.code || ((error?.request || error?.message === "Network Error") ? "ERR_NETWORK" : undefined);
  // No conservar cuerpos, cabeceras o credenciales en el error entregado a la interfaz.
  normalized.config = { url: error?.config?.url || error?.response?.config?.url, method: error?.config?.method };
  if (error?.response) {
    let code = error.response.data?.error_code;
    if (normalized.message === messages.SIGNUP_TOO_SOON) code = "SIGNUP_TOO_SOON";
    if (normalized.message === messages.INVALID_2FA_CODE) code = "INVALID_2FA_CODE";
    normalized.response = {
      status: error.response.status,
      data: { error_code: code, message: normalized.message },
    };
  }
  return normalized;
};
